// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { StorageTotals } from "./StorageTotals";
import {
  StorageTotalsFromJSON,
  StorageTotalsFromJSONTyped,
  StorageTotalsToJSON,
  StorageTotalsToJSONTyped,
} from "./StorageTotals";

/**
 *
 * @export
 * @interface StorageUsage
 */
export interface StorageUsage {
  /**
   *
   */
  totals: StorageTotals;
  /**
   *
   */
  projects?: { [key: string]: StorageTotals };
}

/**
 * Check if a given object implements the StorageUsage interface.
 */
export function instanceOfStorageUsage(value: object): value is StorageUsage {
  if (!("totals" in value) || value["totals"] === undefined) return false;
  return true;
}

export function StorageUsageFromJSON(json: any): StorageUsage {
  return StorageUsageFromJSONTyped(json, false);
}

export function StorageUsageFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageUsage {
  if (json == null) {
    return json;
  }
  return {
    totals: StorageTotalsFromJSON(json["totals"]),
    projects:
      json["projects"] == null ? undefined : mapValues(json["projects"], StorageTotalsFromJSON),
  };
}

export function StorageUsageToJSON(json: any): StorageUsage {
  return StorageUsageToJSONTyped(json, false);
}

export function StorageUsageToJSONTyped(
  value?: StorageUsage | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    totals: StorageTotalsToJSON(value["totals"]),
    projects:
      value["projects"] == null ? undefined : mapValues(value["projects"], StorageTotalsToJSON),
  };
}
